/* =========================================================
   mse Warenkorb (Panel und Warenkorbseite), Umbau 25.09.2026
   nach dem abgenommenen Warenkorb-Mockup vom 22.09.2026.

   - Warenkorb-Link in der mse-Topbar öffnet das Panel (Dawn bindet
     das Panel nur an den versteckten Original-Link #cart-icon-bubble).
   - Zähler am Topbar-Symbol folgt dem Dawn-Zähler (#cart-icon-bubble).
   - mse-cart-discount: Rabattcode anwenden und entfernen (/cart/update.js).
   - mse-cart-upsell: „Ergänze deinen Einkauf", erst ergänzende Produkte
     aus Search & Discovery (intent=complementary), sonst intent=related.
   - mse-cart-attribute: USt-IdNr. als Warenkorb-Attribut (vorher Inline-
     Skript in snippets/mse-cart-vat-id.liquid).
   Setzt global.js, pubsub.js, constants.js und cart.js von Dawn voraus.
   ========================================================= */

(function () {
  if (window.MseCart) return;

  var UPSELL_TTL = 10 * 60 * 1000;
  var upsellCache = {};

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  function isCartPage() {
    return !!document.getElementById('main-cart-items');
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  /* Welche Sections bei einer Änderung neu gerendert werden müssen. */
  function sectionsToRequest() {
    var list = [];
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) list.push(items.dataset.id);
    if (footer && footer.dataset.id) list.push(footer.dataset.id);
    if (getDrawer()) list.push('cart-drawer');
    list.push('cart-icon-bubble');
    return list;
  }

  /* Neu gerenderte Sections einsetzen, ohne das Panel zu öffnen. */
  function renderSections(sections, itemCount) {
    if (!sections) return;
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var drawer = getDrawer();

    function swap(html, sourceSelector, target) {
      if (!html || !target) return;
      var source = parseHTML(html).querySelector(sourceSelector);
      if (source) target.innerHTML = source.innerHTML;
    }

    if (items) swap(sections[items.dataset.id], '.js-contents', items.querySelector('.js-contents'));
    if (footer) swap(sections[footer.dataset.id], '.js-contents', footer.querySelector('.js-contents'));
    if (drawer) swap(sections['cart-drawer'], '.drawer__inner', drawer.querySelector('.drawer__inner'));
    swap(sections['cart-icon-bubble'], '.shopify-section', document.getElementById('cart-icon-bubble'));

    if (typeof itemCount === 'number') {
      var empty = itemCount === 0;
      if (drawer) drawer.classList.toggle('is-empty', empty);
      var cartItems = document.querySelector('cart-items');
      if (cartItems) cartItems.classList.toggle('is-empty', empty);
      if (footer) footer.classList.toggle('is-empty', empty);
    }
  }

  window.MseCart = {
    renderSections: renderSections,
    sectionsToRequest: sectionsToRequest,
  };

  /* ---------- Topbar: Link öffnet das Panel, Zähler folgt ---------- */

  function mirrorBadge() {
    var bubble = document.getElementById('cart-icon-bubble');
    var link = document.getElementById('mse-cart-icon-bubble');
    if (!bubble || !link) return;
    var wrap = link.querySelector('.mse-topbar__cart-wrap');
    if (!wrap) return;

    var count = bubble.querySelector('.cart-count-bubble');
    var badge = wrap.querySelector('.mse-topbar__cart-badge');
    if (!count) {
      if (badge) badge.remove();
      return;
    }
    var number = count.querySelector('span[aria-hidden="true"]');
    var text = number ? number.textContent.trim() : '';
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'mse-topbar__cart-badge';
      wrap.appendChild(badge);
    }
    var current = badge.querySelector('span[aria-hidden="true"]');
    if (current && current.textContent.trim() === text) return;
    badge.innerHTML = text ? '<span aria-hidden="true">' + text + '</span>' : '';
  }

  function bindTopbar() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && !bubble.dataset.mseMirror) {
      bubble.dataset.mseMirror = '1';
      new MutationObserver(mirrorBadge).observe(bubble, { childList: true, subtree: true, characterData: true });
    }

    var link = document.getElementById('mse-cart-icon-bubble');
    var drawer = getDrawer();
    if (!link || !drawer || link.dataset.mseCartBound || isCartPage()) return;
    link.dataset.mseCartBound = '1';
    link.setAttribute('role', 'button');
    link.setAttribute('aria-haspopup', 'dialog');
    link.addEventListener('click', function (event) {
      if (typeof drawer.open !== 'function') return;
      event.preventDefault();
      drawer.open(link);
    });
    link.addEventListener('keydown', function (event) {
      if (event.code === 'Space' && typeof drawer.open === 'function') {
        event.preventDefault();
        drawer.open(link);
      }
    });
  }

  /* Dawn setzt ein ungültiges Mengenfeld nur über #Quantity-N zurück (Warenkorbseite).
     Im Panel heißt das Feld #Drawer-quantity-N, dort lief das ins Leere und warf einen Fehler. */
  function patchDrawerItems() {
    var DrawerItems = customElements.get('cart-drawer-items');
    if (!DrawerItems || DrawerItems.prototype.mseResetPatched) return;
    DrawerItems.prototype.mseResetPatched = true;
    DrawerItems.prototype.resetQuantityInput = function (id) {
      var input = this.querySelector('#Drawer-quantity-' + id);
      if (input) input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindTopbar);
  } else {
    bindTopbar();
  }

  // cart-drawer.js steht im Dokument nach dieser Datei, deshalb erst patchen, wenn das Element definiert ist.
  customElements.whenDefined('cart-drawer-items').then(patchDrawerItems);

  /* ---------- USt-IdNr. (Warenkorb-Attribut) ---------- */

  window.mseCartAttributePending = window.mseCartAttributePending || {};

  if (!customElements.get('mse-cart-attribute')) {
    customElements.define(
      'mse-cart-attribute',
      class MseCartAttribute extends HTMLElement {
        connectedCallback() {
          this.input = this.querySelector('input');
          if (!this.input) return;

          var pending = window.mseCartAttributePending[this.dataset.attribute];
          if (typeof pending === 'string' && pending !== this.input.value) this.input.value = pending;

          if (this.bound) return;
          this.bound = true;
          this.timer = null;
          this.input.addEventListener('input', (event) => {
            event.stopPropagation();
            window.mseCartAttributePending[this.dataset.attribute] = this.input.value;
            this.syncOthers();
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.save(), 400);
          });
          this.input.addEventListener('change', (event) => {
            event.stopPropagation();
            clearTimeout(this.timer);
            this.save();
          });
        }

        syncOthers() {
          var key = this.dataset.attribute;
          var value = this.input.value;
          document.querySelectorAll('mse-cart-attribute').forEach((el) => {
            if (el === this || el.dataset.attribute !== key) return;
            var other = el.querySelector('input');
            if (other && other.value !== value) other.value = value;
          });
        }

        save() {
          var key = this.dataset.attribute;
          var value = this.input.value.trim();
          var attributes = {};
          attributes[key] = value;
          fetch(routes.cart_update_url, Object.assign({}, fetchConfig(), { body: JSON.stringify({ attributes: attributes }) }))
            .then(function (response) {
              var pending = window.mseCartAttributePending[key];
              if (response.ok && typeof pending === 'string' && pending.trim() === value) {
                delete window.mseCartAttributePending[key];
              }
            })
            .catch(function () {});
        }
      }
    );
  }

  /* ---------- Rabattcode ---------- */

  var MSE_STRINGS = (typeof window !== 'undefined' && window.mseStrings) || {};

  var DISCOUNT_ERRORS = {
    empty: MSE_STRINGS.rabattLeer || 'Bitte gib einen Rabattcode ein.',
    duplicate: MSE_STRINGS.rabattDoppelt || 'Dieser Rabattcode ist bereits eingelöst.',
    invalid: MSE_STRINGS.rabattUngueltig || 'Dieser Rabattcode kann nicht angewendet werden.',
    failed: MSE_STRINGS.rabattTechnisch || 'Der Rabattcode konnte gerade nicht geprüft werden. Bitte versuche es erneut.',
  };

  function updateDiscounts(codes) {
    var body = JSON.stringify({
      discount: codes.join(','),
      sections: sectionsToRequest(),
      sections_url: window.location.pathname,
    });
    return fetch(routes.cart_update_url, Object.assign({}, fetchConfig(), { body: body })).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.json();
    });
  }

  function discountElement(context) {
    return document.querySelector('mse-cart-discount[data-context="' + context + '"]');
  }

  if (!customElements.get('mse-cart-discount')) {
    customElements.define(
      'mse-cart-discount',
      class MseCartDiscount extends HTMLElement {
        connectedCallback() {
          if (this.bound) return;
          this.bound = true;
          this.input = this.querySelector('input');
          this.applyButton = this.querySelector('.mse-cart-discount__apply');
          this.errorElement = this.querySelector('.mse-cart-discount__error');

          if (this.applyButton) this.applyButton.addEventListener('click', () => this.apply());
          if (this.input) {
            this.input.addEventListener('keydown', (event) => {
              if (event.key === 'Enter') {
                event.preventDefault();
                this.apply();
              }
            });
            this.input.addEventListener('input', () => this.showError(''));
            this.input.addEventListener('change', (event) => event.stopPropagation());
          }
          this.querySelectorAll('[data-remove-code]').forEach((button) => {
            button.addEventListener('click', () => this.remove(button.dataset.removeCode));
          });
        }

        codes() {
          try {
            return JSON.parse(this.dataset.codes || '[]');
          } catch (e) {
            return [];
          }
        }

        showError(message) {
          if (!this.errorElement) return;
          this.errorElement.textContent = message;
          this.errorElement.hidden = !message;
          if (this.input) this.input.setAttribute('aria-invalid', message ? 'true' : 'false');
        }

        setBusy(busy) {
          this.classList.toggle('is-busy', busy);
          if (this.applyButton) {
            this.applyButton.disabled = busy;
            this.applyButton.setAttribute('aria-busy', busy ? 'true' : 'false');
          }
        }

        apply() {
          var code = this.input ? this.input.value.trim() : '';
          var context = this.dataset.context;
          if (!code) {
            this.showError(DISCOUNT_ERRORS.empty);
            return;
          }
          var existing = this.codes();
          if (existing.some((c) => c.toLowerCase() === code.toLowerCase())) {
            this.showError(DISCOUNT_ERRORS.duplicate);
            return;
          }

          this.setBusy(true);
          updateDiscounts(existing.concat([code]))
            .then((data) => {
              var entry = (data.discount_codes || []).find((d) => String(d.code).toLowerCase() === code.toLowerCase());
              if (entry && entry.applicable) {
                renderSections(data.sections, data.item_count);
                var fresh = discountElement(context);
                if (fresh && fresh.input) fresh.input.focus();
                return;
              }
              // Ungültiger Code: wieder aus dem Warenkorb nehmen, damit er nicht im Checkout auftaucht.
              return updateDiscounts(existing).then((clean) => {
                renderSections(clean.sections, clean.item_count);
                var fresh = discountElement(context);
                if (fresh) {
                  if (fresh.input) {
                    fresh.input.value = code;
                    fresh.input.focus();
                  }
                  fresh.showError(DISCOUNT_ERRORS.invalid);
                }
              });
            })
            .catch(() => {
              var target = discountElement(context) || this;
              target.showError(DISCOUNT_ERRORS.failed);
            })
            .finally(() => {
              var target = discountElement(context);
              if (target) target.setBusy(false);
              if (target !== this) this.setBusy(false);
            });
        }

        remove(code) {
          var context = this.dataset.context;
          var rest = this.codes().filter((c) => c !== code);
          this.setBusy(true);
          updateDiscounts(rest)
            .then((data) => {
              renderSections(data.sections, data.item_count);
              var fresh = discountElement(context);
              if (fresh && fresh.input) fresh.input.focus();
            })
            .catch(() => this.showError(DISCOUNT_ERRORS.failed))
            .finally(() => {
              var target = discountElement(context);
              if (target) target.setBusy(false);
              if (target !== this) this.setBusy(false);
            });
        }
      }
    );
  }

  /* ---------- „Ergänze deinen Einkauf" ---------- */

  function fetchUpsell(url, productId, intent) {
    var key = productId + '|' + intent;
    if (upsellCache[key] !== undefined) return Promise.resolve(upsellCache[key]);
    try {
      var stored = JSON.parse(sessionStorage.getItem('mseCartUpsell:' + key) || 'null');
      if (stored && Date.now() - stored.t < UPSELL_TTL) {
        upsellCache[key] = stored.h;
        return Promise.resolve(stored.h);
      }
    } catch (e) {}

    var requestUrl =
      url +
      '?section_id=mse-cart-upsell&product_id=' +
      encodeURIComponent(productId) +
      '&limit=10&intent=' +
      intent;
    return fetch(requestUrl)
      .then(function (response) {
        return response.ok ? response.text() : '';
      })
      .then(function (text) {
        var result = text ? parseHTML(text).querySelector('.mse-cart-upsell__result') : null;
        var html = result ? result.innerHTML.trim() : '';
        upsellCache[key] = html;
        try {
          sessionStorage.setItem('mseCartUpsell:' + key, JSON.stringify({ t: Date.now(), h: html }));
        } catch (e) {}
        return html;
      })
      .catch(function () {
        return '';
      });
  }

  if (!customElements.get('mse-cart-upsell')) {
    customElements.define(
      'mse-cart-upsell',
      class MseCartUpsell extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.mse-cart-upsell__track');
          this.errorElement = this.querySelector('.mse-cart-upsell__error');
          if (!this.track) return;

          if (!this.bound) {
            this.bound = true;
            this.track.addEventListener('click', (event) => {
              var button = event.target.closest('.mse-cart-upsell__add');
              if (button) {
                event.preventDefault();
                this.add(button);
              }
            });
          }

          var drawer = getDrawer();
          if (!drawer || drawer.classList.contains('active')) {
            this.load();
          } else {
            this.observer = new MutationObserver(() => {
              if (drawer.classList.contains('active')) {
                this.observer.disconnect();
                this.load();
              }
            });
            this.observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        tilesFrom(html, exclude) {
          if (!html) return [];
          var holder = document.createElement('div');
          holder.innerHTML = html;
          return Array.prototype.filter.call(holder.querySelectorAll('.mse-cart-upsell__tile'), function (tile) {
            return exclude.indexOf(tile.dataset.productId) === -1;
          });
        }

        load() {
          if (this.loading) return;
          this.loading = true;
          var url = this.dataset.url;
          var productId = this.dataset.productId;
          if (!url || !productId) return;
          var exclude = (this.dataset.exclude || '').split(',').filter(Boolean);

          fetchUpsell(url, productId, 'complementary')
            .then((html) => {
              var tiles = this.tilesFrom(html, exclude);
              if (tiles.length) return tiles;
              return fetchUpsell(url, productId, 'related').then((related) => this.tilesFrom(related, exclude));
            })
            .then((tiles) => {
              if (!this.isConnected) return;
              if (!tiles.length) {
                this.hidden = true;
                return;
              }
              this.track.replaceChildren.apply(this.track, tiles.slice(0, 6));
              this.hidden = false;
            });
        }

        add(button) {
          if (button.getAttribute('aria-disabled') === 'true') return;
          var drawer = getDrawer();
          var spinner = button.querySelector('.loading__spinner');
          button.setAttribute('aria-disabled', 'true');
          button.classList.add('loading');
          if (spinner) spinner.classList.remove('hidden');
          if (this.errorElement) this.errorElement.hidden = true;

          var sections = drawer && typeof drawer.getSectionsToRender === 'function'
            ? drawer.getSectionsToRender().map(function (s) { return s.id; })
            : ['cart-icon-bubble'];
          var body = JSON.stringify({
            items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
            sections: sections,
            sections_url: window.location.pathname,
          });

          fetch(routes.cart_add_url, Object.assign({}, fetchConfig(), { body: body }))
            .then(function (response) {
              return response.json();
            })
            .then((data) => {
              if (data.status) {
                if (this.errorElement) {
                  this.errorElement.textContent = data.description || data.message || window.cartStrings.error;
                  this.errorElement.hidden = false;
                }
                return;
              }
              if (drawer && typeof drawer.renderContents === 'function') {
                drawer.renderContents(data);
              } else {
                renderSections(data.sections);
              }
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'mse-cart-upsell',
                  cartData: data,
                  productVariantId: button.dataset.variantId,
                });
              }
            })
            .catch(() => {
              if (this.errorElement) {
                this.errorElement.textContent = window.cartStrings.error;
                this.errorElement.hidden = false;
              }
            })
            .finally(function () {
              if (!button.isConnected) return;
              button.removeAttribute('aria-disabled');
              button.classList.remove('loading');
              if (spinner) spinner.classList.add('hidden');
            });
        }
      }
    );
  }
})();
